import React from "react";
import { Paper } from "@mantine/core";

const Wrapper = ({ children }) => (
  <Paper
    shadow="xl"
    p="lg"
    radius="md"
    style={{
      backgroundColor: `rgba(0, 0, 0, 0.88)`,
    }}
  >
    {children}
  </Paper>
);

export default Wrapper;
